"use strict";

// Кнопка входа в систему.

import analytics from "../marketing/analytics";
import dom from "../dom";

function listenSigninClick() {
    var btn = document.querySelector("#signin");
    if (!btn) {
        return;
    }
    btn.addEventListener("click", function () {
        analytics.reachGoal("SIGNIN");
    });
}

dom.callAfterLoaded(function () {
    listenSigninClick();
});

export default {};
